export default __webpack_public_path__ + "static/media/statistikIcon.c4c73bf8.svg";